import {http, onSuccess, onFail} from './http';

export const createEpisodeFile = (episodeId, data) => {
    const form = new FormData();
    Object.keys(data || {}).forEach(key => form.append(key, data[key]));
    return http.post(`/api/cp/event/stream/episode/${episodeId}/file`, form)
        .then(onSuccess, onFail);
};

export const updateEpisodeFile = (fileId, data) => {
    const form = new FormData();
    Object.keys(data || {}).forEach(key => form.append(key, data[key]));
    return http.post(`/api/cp/event/stream/episode/file/${fileId}`, form)
        .then(onSuccess, onFail);
};

export const deleteEpisodeFile = (fileId) => {
    return http.delete(`/api/cp/event/stream/episode/file/${fileId}`)
        .then(onSuccess, onFail);
};

export const updateEpisodeFilesOrder = (episode, payload) => {
    return http.post(`/api/cp/event/stream/episode/${episode}/file-order`, {sortOrder: payload})
        .then(onSuccess, onFail);
};
